import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentService } from '../../../services/document/document.service';
import { trashIcon, downloadIcon, SVGIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'ags-document-management',
  templateUrl: './document-management.component.html',
  styleUrls: ['./document-management.component.scss']
})
export class DocumentManagementComponent implements OnInit {
  public listInfoDoc: any[];
  public listUrlDoc: any[] = null;
  public popupIsOpen: boolean;
  public idDoc: number;
  public svgDownload: SVGIcon = downloadIcon;
  public svgTrash: SVGIcon = trashIcon;

  @Input('listInfoDoc')
  set _listInfoDoc(value: any[]) {
    if (value) {
      this.listInfoDoc = value;
    }
  }

  @Input('listUrlDoc')
  set _listUrlDoc(value: any[]) {
    if (value) {
      this.listUrlDoc = value;
    }
  }

  @Output() updateList = new EventEmitter();

  constructor(private documentService: DocumentService) {}

  ngOnInit(): void {
    this.popupIsOpen = false;
    this.idDoc = null;
  }

  public close() {
    this.popupIsOpen = false;
  }

  public open(id: number) {
    this.idDoc = id;
    this.popupIsOpen = true;
  }

  deleteDoc() {
    this.documentService.deleteDocument(this.idDoc).subscribe(res => {
      this.updateList.emit(res);
    });
    this.popupIsOpen = false;
  }
}
